import { statesList } from '@utils';

const key = import.meta.env.VITE_GEOCODE_API_KEY;

interface Address {
  long_name: string;
  short_name: string;
  types: string[];
}

interface Response {
  results: {
    address_components: Address[];
    types: string[];
  }[];
  status: string;
}

const fetchGeocodeData = async (zipCode: string): Promise<Response> => {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${key}`;
  const res = await fetch(url);
  return res.json();
};

export const getStateFromZipCode = async (zipCode: string) => {
  try {
    const data = await fetchGeocodeData(zipCode);

    for (const location of data.results) {
      for (const address of location.address_components) {
        const match = statesList.find(
          (state: { value: string; label: string }) => {
            return (
              address.short_name === state.value &&
              address.long_name === state.label
            );
          }
        );

        if (match) {
          return match.value;
        }
      }
    }
  } catch {
    return;
  }
};
